module.exports = __webpack_public_path__ + "img/ico-logout.0d45002d.svg";